import { format, isToday, isYesterday, parseISO } from "date-fns";

import { MESSAGE_TRUNCATE_LENGTH, MESSAGE_TYPE } from "@/domains/messages/models/constants";
import type { MessageResponse } from "@/domains/messages/models/types";

export const createMessageDataModel = (message: MessageResponse) => {
  return {
    ...message,
    isOwnMessage: message.type === MESSAGE_TYPE.USER,
    isEvent: message.type === MESSAGE_TYPE.EVENT,
    exceedsTruncateLength: message.content.length > MESSAGE_TRUNCATE_LENGTH,
    displayCreatedAtDate: getDisplayDate(message.createdAt),
    displayCreatedAtTime: getDisplayTime(message.createdAt),
  };
};

export const getDisplayDate = (dateString: string) => {
  const parsedDate = parseISO(dateString);
  if (isToday(parsedDate)) {
    return "Today";
  }
  if (isYesterday(parsedDate)) {
    return "Yesterday";
  }

  return format(parsedDate, "EEE, MMM d");
};

const getDisplayTime = (dateString: string) => {
  const parsedDate = parseISO(dateString);

  return format(parsedDate, "h:mmaaa");
};
